import { render, staticRenderFns } from "./AuthorAdd.vue?vue&type=template&id=f0373d4e&scoped=true"
import script from "./AuthorAdd.vue?vue&type=script&lang=js"
export * from "./AuthorAdd.vue?vue&type=script&lang=js"
import style0 from "./AuthorAdd.vue?vue&type=style&index=0&id=f0373d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0373d4e",
  null
  
)

export default component.exports